import type { IconProps } from './icons.types';

export function CheckIcon({ size = 12 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M9.55 17.6538L4.2155 12.3193L5.2845 11.25L9.55 15.5155L18.7155 6.35001L19.7845 7.41926L9.55 17.6538Z" />
    </svg>
  );
}
